import script from "./FnolInputForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./FnolInputForm.vue?vue&type=script&setup=true&lang=ts"

import "./FnolInputForm.vue?vue&type=style&index=0&id=78a048be&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a048be"]])

export default __exports__